<template>
  <div class="n-option">
    <div class="n-option_content">
      <el-button
        class="n-option_content-button"
        type="text"
        v-for="item in showList"
        :disabled="item | isShow(data)"
        :key="item.key"
        @click="onClick(item)"
      >
        {{ item.label }}
      </el-button>
    </div>
    <el-popover
      trigger="click"
      class="n-option_beyond"
      v-if="list.length > maxLength"
      v-model="visible"
    >
      <el-button class="n-option_beyond-button" type="text" slot="reference">
        更多
      </el-button>
      <!--   超出的列表   -->
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        "
      >
        <el-button style="margin-left:10px;"
          type="text"
          v-for="item in beyondList"
          :key="item.key"
          @click="onClick(item, 'beyond')"
          :disabled="item | isShow(data)"
        >
          {{ item.label }}
        </el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "n-option",
  props: {
    list: {
      type: Array,
      required: true,
    },
    maxLength: {
      type: Number,
      default: 2,
    },
    limit: {
      type: Number,
      default: Infinity,
    },
    tab: {
      type: String,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    /**
     * 筛选设置了 sort 的数据
     * @returns {[]}
     */
    showList() {
      let arr = this.sortFilter(this.list);
      // 当具有 sort 的选项不够时，补齐
      if (arr.length < this.maxLength) {
        arr = arr.concat(
          this.notSortFilter(this.list).splice(0, this.maxLength - arr.length)
        );
      }
      return arr;
    },
    /**
     * 筛选没有设置 sort 的数据
     * @returns {[]}
     */
    beyondList() {
      let arr = this.sortFilter(this.list);
      let beyond = this.notSortFilter(this.list);
      // 当具有 sort 的选项不够时，补齐
      if (arr.length < this.maxLength) {
        beyond.splice(0, this.maxLength - arr.length);
      }
      return beyond;
    },
  },
  filters: {
    /**
     *
     * @param item {Object} 配置项
     * @param row {Object}
     * @returns {boolean}
     */
    isShow: function (item, row) {
      let state = true;
      if (item.isShow) {
        if (row) {
          state = item.isShow(row);
        } else {
          console.error("n-option：data 数据缺失");
        }
      }
      return !state;
    },
  },
  methods: {
    /**
     * 限制字数
     * @param val {Array} 需要限制的数组
     * @returns {(string|*)[]}
     */
    arrSlice(val) {
      let arr = [...val];

      arr = arr.map((item) => {
        return item.label.length > this.limit
          ? item.label.slice(0, this.limit) + "..."
          : item.label;
      });

      return arr;
    },
    /**
     * 筛选出有 sort 项,并按 sort 排序
     * @param list 原始数据
     * @returns {[]}
     */
    sortFilter(list) {
      let sortArr = [];
      sortArr = list.filter((item) => {
        return item.hasOwnProperty("sort");
      });

      sortArr = sortArr.sort((a, b) => {
        return a.sort - b.sort;
      });

      return sortArr;
    },
    /**
     * 筛选出没有 sort 项,并排序
     * @param list
     * @returns {*|*[]}
     */
    notSortFilter(list) {
      let sortArr = [];
      sortArr = list.filter((item) => {
        return !item.hasOwnProperty("sort");
      });

      sortArr = sortArr.sort((a, b) => {
        if (a.label.length - b.label.length == 0) {
          if (a.label.toUpperCase() < b.label.toUpperCase()) {
            return -1;
          }
          if (a.label.toUpperCase() > b.label.toUpperCase()) {
            return 1;
          }
          return 0;
        }
        return a.label.length - b.label.length;
      });

      return sortArr;
    },
    /**
     * 监听按钮触发，抛出 change 事件
     * @param row
     */
    onClick(row, type) {
      let obj = { ...row };
      if (type == "beyond") {
        this.visible = false;
      }
      // 清除无用的项
      delete obj.isShow;

      this.$emit("change", obj);
    },
  },
};
</script>

<style lang="less">
.n-option {
  width: 100%;
  display: flex;
  align-items: center;

  &_content {
    flex-shrink: 0;

    &-button {
      margin: 0 12px;
    }
  }

  &_beyond {
    flex-shrink: 0;

    &-button {
      margin: 0 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Option/src/option.vue